import { useContext } from 'react';
import { SimpleGrid, Space, Stack } from '@mantine/core';
import { i18n } from '@lingui/core';
import validator from 'validator';
import { ProfileContext } from '../Service/Context/ProfileContext';
import { ShareProfile } from '../Templates/Settings/Share/ShareProfile';
import { ContactContext } from '../Service/Context/ContactContext';
import BookitupTextInput from '../Atoms/inputs/BookitupTextInput';
import { ValidationS } from '../Service/ValidationS';
import BankAccountSettings from './Settings/BankAccountSettings';
import ContactForm from './ContactForm';
import FinancialForm from './FinancialForm';
import PanePaper from './PanePaper';
import AdditionalInfoSettings from './Settings/AdditionalInfoSettings';
import WebPresentationSettings from './Settings/WebPresentationSettings';

const ProfileSection = () => {
  const { profile, patchProfile } = useContext(ProfileContext);
  const { contact, handleContactChange, saveContactChange } = useContext(ContactContext);
  const { companyName, firstName, lastName, email } = contact;
  const { alias } = profile;

  return (
    <>
      <SimpleGrid
        cols={5}
        breakpoints={[
          { maxWidth: 'xl', cols: 3 },
          { maxWidth: 'md', cols: 2 },
          { maxWidth: 'sm', cols: 2 },
          { maxWidth: 'xs', cols: 1 },
        ]}
      >
        <PanePaper title="common.settings.profile">
          <Stack spacing="xs">
            <BookitupTextInput
              label={i18n._('contact.companyName')}
              defaultValue={companyName}
              onBlurSave={(val) => saveContactChange({ companyName: val })}
            />
            <BookitupTextInput
              label={i18n._('applicationuser.alias')}
              defaultValue={alias}
              onBlurSave={(val) => patchProfile({ alias: val })}
            />
            <BookitupTextInput
              label={i18n._('contact.firstName')}
              defaultValue={firstName}
              onBlurSave={(val) => saveContactChange({ firstName: val })}
              validate={ValidationS.validAwsObjectKeyName}
              errorMessage={i18n._('error.input-field.invalid-aws-char')}
            />
            <BookitupTextInput
              label={i18n._('contact.lastName')}
              defaultValue={lastName}
              onBlurSave={(val) => saveContactChange({ lastName: val })}
              validate={ValidationS.validAwsObjectKeyName}
              errorMessage={i18n._('error.input-field.invalid-aws-char')}
            />
            <BookitupTextInput
              label={i18n._('contact.email')}
              defaultValue={email}
              onBlurSave={(val) => saveContactChange({ email: val })}
              validate={validator.isEmail}
              errorMessage="Bitte gib eine valide E-Mail-Adresse ein"
            />
          </Stack>
        </PanePaper>

        <ContactForm changeHandler={handleContactChange} contact={contact} hideEmail />

        <AdditionalInfoSettings />
        <WebPresentationSettings />
      </SimpleGrid>
      <Space h="md" />
      <SimpleGrid
        cols={5}
        breakpoints={[
          { maxWidth: 'xl', cols: 3 },
          { maxWidth: 'md', cols: 2 },
          { maxWidth: 'sm', cols: 2 },
          { maxWidth: 'xs', cols: 1 },
        ]}
      >
        <FinancialForm />

        <BankAccountSettings />
        <ShareProfile />
      </SimpleGrid>
    </>
  );
};

export default ProfileSection;
